var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row q-gutter-x-sm" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "q-list",
              { staticClass: "basic-info-list" },
              [
                _vm.palletArea
                  ? _c(
                      "q-item",
                      { attrs: { dense: "" } },
                      [
                        _c(
                          "q-item-section",
                          [
                            _c("q-item-label", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("palletArea")))])
                            ]),
                            _vm._v(" "),
                            _c("q-item-label", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("area")(
                                    _vm.palletArea,
                                    _vm.unitLabel("sqm"),
                                    _vm.userLocale
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "q-list",
              { staticClass: "basic-info-list" },
              [
                _vm.maxLength
                  ? _c(
                      "q-item",
                      { attrs: { dense: "" } },
                      [
                        _c(
                          "q-item-section",
                          [
                            _c("q-item-label", [
                              _c("span", [_vm._v(_vm._s(_vm.$t("maxLength")))])
                            ]),
                            _vm._v(" "),
                            _c("q-item-label", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberWithUnit")(
                                    _vm.maxLength,
                                    "cm",
                                    _vm.userLocale
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("q-slide-transition", [
        !_vm.collapsed
          ? _c(
              "div",
              [
                _c("div", { staticClass: "row q-gutter-x-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "q-list",
                        { staticClass: "basic-info-list" },
                        [
                          _vm.place && _vm.user && !_vm.simplified
                            ? _c(
                                "q-item",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "q-item-section",
                                    [
                                      _c("q-item-label", [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("place")))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("q-item-label", [
                                        _vm._v(_vm._s(_vm.place))
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resultAreaNotRemeasured
                            ? _c(
                                "q-item",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "q-item-section",
                                    [
                                      _c("q-item-label", [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("packageArea")))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("q-item-label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("area")(
                                              _vm.resultAreaNotRemeasured,
                                              _vm.unitLabel("sqm"),
                                              _vm.userLocale
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resultAreaNotRemeasured && _vm.palletArea
                            ? _c(
                                "q-item",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "q-item-section",
                                    [
                                      _c("q-item-label", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("inPalletPercentage"))
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("q-item-label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("numberWithUnit")(
                                              (_vm.resultAreaNotRemeasured /
                                                _vm.palletArea) *
                                                100,
                                              _vm.unitLabel("percentage"),
                                              _vm.userLocale,
                                              0,
                                              0
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "q-list",
                        { staticClass: "basic-info-list" },
                        [
                          _vm.bundleCount
                            ? _c(
                                "q-item",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "q-item-section",
                                    [
                                      _c("q-item-label", [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("bundleCount")))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("q-item-label", [
                                        _vm._v(_vm._s(_vm.bundleCount))
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resultAreaMeasuredBack
                            ? _c(
                                "q-item",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "q-item-section",
                                    [
                                      _c("q-item-label", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("measuredArea")) +
                                              " (" +
                                              _vm._s(_vm.$t("unit.sqm")) +
                                              ")"
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("q-item-label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("area")(
                                              _vm.resultAreaMeasuredBack,
                                              _vm.unitLabel("sqm"),
                                              _vm.userLocale
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resultAreaMeasuredBack &&
                          _vm.resultAreaNotRemeasured
                            ? _c(
                                "q-item",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "q-item-section",
                                    [
                                      _c("q-item-label", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("measuredArea")) +
                                              " (" +
                                              _vm._s(
                                                _vm.$t("unit.percentage")
                                              ) +
                                              ")"
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("q-item-label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("numberWithUnit")(
                                              (_vm.resultAreaMeasuredBack /
                                                _vm.resultAreaNotRemeasured) *
                                                100,
                                              _vm.unitLabel("percentage"),
                                              _vm.userLocale,
                                              0,
                                              0
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.user && !_vm.simplified
                  ? [
                      _c("q-separator", { attrs: { spaced: "" } }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "extended-info-list q-pt-sm" },
                        [
                          _c(
                            "q-list",
                            { staticClass: "basic-info-list" },
                            [
                              _vm.palletInfo
                                ? _c(
                                    "q-item",
                                    [
                                      _c(
                                        "q-item-section",
                                        [
                                          _c("q-item-label", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("palletInfo"))
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("q-item-label", [
                                            _vm._v(_vm._s(_vm.palletInfo))
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.palletInfoInternal
                                ? _c(
                                    "q-item",
                                    [
                                      _c(
                                        "q-item-section",
                                        [
                                          _c("q-item-label", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("palletInfoInternal")
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("q-item-label", [
                                            _vm._v(
                                              _vm._s(_vm.palletInfoInternal)
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("q-btn", {
        staticClass: "card-collapse-button",
        attrs: {
          flat: "",
          color: "primary",
          icon: _vm.collapsed ? "add" : "remove",
          label: _vm.collapsed ? _vm.$t("more") : _vm.$t("less"),
          padding: "4px 4px 4px 0",
          "no-caps": ""
        },
        on: {
          click: function($event) {
            _vm.collapsed = !_vm.collapsed
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }